import {Pill} from '@wandb/weave/components/Tag';
import React, {FC} from 'react';

export enum ServiceAccountAuthMethod {
  API_KEY = 'API Key',
  FEDERATED = 'Federated Identity',
}

type ServiceAccountPillProps = {
  authMethod: ServiceAccountAuthMethod;
};

export const ServiceAccountAuthPill: FC<ServiceAccountPillProps> = ({
  authMethod,
}) => {
  return authMethod === ServiceAccountAuthMethod.API_KEY ? (
    <Pill className="ml-6" label="Built in" color="teal" />
  ) : (
    <Pill className="ml-6" label="External" color="sienna" />
  );
};
